import { LocationHistory_Read } from '@treadinc/horizon-api-spec';

import { NextBillionAssetLocation } from '~hooks/useNextBillionAssetLocationHistories/models';
import connection from '~services/connectionModule';
import { realTimeChannels } from '~services/realTimeChannels';
import { useStores } from '~store';

interface SubscribeToLastLocationUpdatesProps {
  onMessageCallBack: (data: NextBillionAssetLocation) => void;
  companyId: string;
}

const isValidTruckData = (data: LocationHistory_Read | undefined) => {
  return Boolean(data?.lat && data?.lon);
};

export const useTruckLocations = () => {
  const { liveMapStore } = useStores();

  const subscribeToLastLocationUpdates = ({
    companyId,
    onMessageCallBack,
  }: SubscribeToLastLocationUpdatesProps) => {
    const consumer = connection.realTimeConnection;
    const channel = realTimeChannels.NextBillionLastLocationChannel;

    let subscription = consumer?.subscriptions.subscriptions.find((sub) => {
      return sub.identifier.includes(channel);
    });

    if (!subscription) {
      subscription = consumer?.subscriptions?.create?.(
        {
          channel: channel,
          company_id: companyId,
        },
        {
          // oxlint-disable-next-line @typescript-eslint/no-empty-function
          connected: () => () => {},
          // oxlint-disable-next-line @typescript-eslint/no-empty-function
          disconnected: () => () => {},
          received: ({ data }: { data: LocationHistory_Read }) => {
            if (isValidTruckData(data)) {
              const locationData = NextBillionAssetLocation.parse(data);
              liveMapStore.addTruckLocation(locationData);
              onMessageCallBack(locationData);
            }
          },
        },
      );
    }

    return subscription;
  };

  return { subscribeToLastLocationUpdates };
};
